import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationArchiveVariationsArgs, BackendVariation } from 'src/types/backend';

const MUTATION = gql`
  mutation ArchiveVariations($ids: [ID!]!) {
    archiveVariations(ids: $ids) {
      variations {
        id
      }
    }
  }
`;

type Variables = BackendMutationArchiveVariationsArgs;
type Result = { variations: Pick<BackendVariation, 'id'>[] };

export const archiveVariations = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
